import { AuthenticatedApiRequest } from '@goldspotdiscoveries/auth';
import {
  CompanyObject,
  CompanyRequest,
  CompanySubscriptionObject,
  CompanyUserRequest,
  GetUsersListParams,
  UsersList,
} from '../../TypeScript/interfaces';
import { errorHandler } from '../error/error-handler';
import { parseQueryParams } from '../../utils/helpers/parse-query-params';

export const getCompany = (company: string): Promise<CompanyObject> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest({
      method: 'get',
      apiName: 'Company',
      path: `/${company}`,
    })
      .then((value: any) => {
        const company: CompanyObject = value;
        resolve(company);
      })
      .catch((err) => {
        reject(err);
        errorHandler(err);
      });
  });
};

export const getCompanySubscriptionStatus = (
  company: string
): Promise<CompanySubscriptionObject> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest({
      method: 'get',
      apiName: 'Company',
      path: `/${company}/billing/subscriptions?summary=true`,
    })
      .then((value: any) => {
        const summary: CompanySubscriptionObject = value.items.find(
          (item: CompanySubscriptionObject) => item.type === 'litholens'
        );
        resolve(summary);
      })
      .catch((err) => {
        reject(err);
        errorHandler(err);
      });
  });
};

export const putCompany = (
  company: string,
  body: CompanyRequest = {}
): Promise<string> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest<{ message: string }>({
      method: 'put',
      apiName: 'Company',
      path: `/${company}`,
      postData: {
        body,
      },
    })
      .then((value: { message: string }) => {
        // {message: "Successfully added company; Company ID: {company_in_path}"}
        const company: string = value.message;
        resolve(company);
      })
      .catch((err) => {
        reject(err);
        errorHandler(err);
      });
  });
};

export const putCompanyUser = (
  company: string,
  user: string,
  body: CompanyUserRequest = {}
): Promise<string> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest<{ message: string }>({
      method: 'put',
      apiName: 'Company',
      path: `/${company}/users/${user}`,
      postData: {
        body,
      },
    })
      .then((value) => {
        const response: string = value.message;
        resolve(response);
      })
      .catch((err) => {
        errorHandler(err);
        reject(err);
      });
  });
};

export const getCompanyUsers = ({
  company,
  queryParams,
}: GetUsersListParams) => {
  const validParams = ['next_offset_token', 'limit'];
  const queryParamsString: string = parseQueryParams(
    validParams,
    queryParams || {}
  );
  return AuthenticatedApiRequest<UsersList>({
    method: 'get',
    apiName: 'Company',
    path: `/${company}/users${queryParamsString}`,
  });
};
